import { render, staticRenderFns } from "./ViberCampaignInfoRoute.vue?vue&type=template&id=3f1b0214&scoped=true&"
import script from "./ViberCampaignInfoRoute.vue?vue&type=script&lang=js&"
export * from "./ViberCampaignInfoRoute.vue?vue&type=script&lang=js&"
import style0 from "./ViberCampaignInfoRoute.vue?vue&type=style&index=0&id=3f1b0214&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1b0214",
  null
  
)

export default component.exports